import { configure } from "nprogress";
import request from "../request.js";

//普通登出
export function login_out(data) {
  return request({
    url: "/api/v1/logout",
    headers: { "content-type": "application/json" },
    method: "post",
    data: data,
  });
}

